import { render } from "./Close.vue?vue&type=template&id=22db5602"
const script = {}

import exportComponent from "D:\\Sources\\APRR\\APRR-Mayday\\aprr-mayday-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__